import type { PaginationResponse } from "../../lib/types";

export function hasData(
  value: string | unknown[] | Record<string, unknown> | unknown
): boolean {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return typeof value === "string" ? value.trim() === "" : !!value;
}
